<template>
    <div :style="svgStyle">
        <svg :style="svgStyle">
            <!--            内边框-->
            <path :d="pathString" :stroke="trailColor" :stroke-width="trailWidth" fill-opacity="0"></path>
            <!--            外边框-->
            <path :d="pathString" :stroke="strokeColor" stroke-linecap="round" :stroke-width="strokeWidth"
                  fill-opacity="0" :style="pathStyle"></path>
        </svg>
        <div class="vux-circle-content"><slot></slot></div>
    </div>
</template>

<script>
    export default {
        name: "circularprogressbar",
        props:{
            strokeWidth:{
                type:Number,
                default:1
            },
            strokeColor:{
                type:String,
                default: '#3FC7FA'
            },
            trailWidth:{
                type:Number,
                default:1
            },
            trailColor:{
                type:String,
                default:'#D9D9D9'
            },
            percent:{
                type:Number,
                default:0
            },
            rd:{
                type:Number,
                default:50
            }
        },
        computed:{
            svgStyle(){
                return{
                    'width':`${2*this.rd}px`,
                    'height':`${2*this.rd}px`,
                    'position':'relative'
                }
            },
            radius(){
                return this.rd-this.strokeWidth/2
            },
            pathString(){
                //大写表示绝对定位，小写表示相对定位
                //（弧形命令a）：a rx ry x-axis-rotation large-arc-flag sweep-flag dx dy
                //rx ry 代表x和y轴的半径，x-axis-rotation代表旋转角度；large-arc-flag角度大小0表示小角度弧，1表示大角度弧；
                // sweep-flag弧线方向0表示起点到终点沿逆时针画弧，1表示顺时针画弧；
                return `M ${this.rd},${this.rd} m 0,-${this.radius}
                    a ${this.radius},${this.radius} 0 1 1 0,${2*this.radius}
                    a ${this.radius},${this.radius} 0 1 1 0,-${2*this.radius}`
            },
            len(){
                return Math.PI * 2 * this.radius
            },
            pathStyle(){
                return{
                    'stroke-dasharray':`${this.len}px ${this.len}px`,
                    'stroke-dashoffset':`${((100-this.percent)/100 * this.len)}px`,
                    'transition':'stroke-dashoffset 1s ease'
                }
            }
        }
    }
</script>

<style scoped>
    .vux-circle-content{
        text-align: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
</style>